/* 1119 - home page components. Same rules as gta-pod-product.js:
   plain custom elements, listeners on the element, idempotent definitions. */
(function () {
  'use strict';

  var DESIGN = window.Shopify && window.Shopify.designMode;

  /* ---------- category explorer ----------
     A sticky menu sits over a stack of full-height slides. The menu is built
     from the slides themselves (Horizon does not expose section.blocks to
     Liquid for content_for 'blocks' sections). An IntersectionObserver with a
     -50%/-50% root margin fires only when a slide crosses the middle of the
     viewport, so there is no scroll listener and no per-frame layout read. */
  if (!customElements.get('gtap-explorer')) {
    customElements.define(
      'gtap-explorer',
      class extends HTMLElement {
        connectedCallback() {
          this.nav = this.querySelector('[data-gtap-cat-nav]');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gtap-cat-slide]'));
          if (!this.nav || !this.slides.length) return;

          this.buildMenu();
          this.activeIdx = 0;

          var self = this;
          this.observer = new IntersectionObserver(
            function (entries) {
              for (var i = 0; i < entries.length; i++) {
                if (!entries[i].isIntersecting) continue;
                var idx = self.slides.indexOf(entries[i].target);
                if (idx > -1) self.setActive(idx);
              }
            },
            { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
          );
          this.slides.forEach(function (s) { self.observer.observe(s); });
        }
        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
        buildMenu() {
          var frag = document.createDocumentFragment();
          this.slides.forEach(function (slide, i) {
            var label = slide.getAttribute('data-label');
            if (!label) return;
            var href = slide.getAttribute('data-href');
            var a = document.createElement('a');
            a.className = 'gtap-explore__link';
            a.textContent = label;
            a.href = href && href !== '' ? href : '#' + slide.id;
            a.setAttribute('data-gtap-cat-link', '');
            a.setAttribute('data-active', i === 0 ? 'true' : 'false');
            frag.appendChild(a);
          });
          this.nav.textContent = '';
          this.nav.appendChild(frag);
          this.links = Array.prototype.slice.call(this.nav.querySelectorAll('[data-gtap-cat-link]'));
        }
        setActive(idx) {
          if (idx === this.activeIdx || !this.links) return;
          this.activeIdx = idx;
          for (var j = 0; j < this.links.length; j++) {
            this.links[j].setAttribute('data-active', j === idx ? 'true' : 'false');
          }
        }
      }
    );
  }

  /* ---------- films: thumbnail selects the stage ---------- */
  if (!customElements.get('gtap-films')) {
    customElements.define(
      'gtap-films',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick);
          var first = this.querySelector('[data-gtap-film]');
          if (first) first.setAttribute('aria-current', 'true');
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }
        onClick = (e) => {
          var card = e.target.closest('[data-gtap-film]');
          if (!card || !this.contains(card)) return;
          this.select(card);
        };
        select(card) {
          var stage = this.querySelector('[data-gtap-film-stage]');
          if (!stage) return;
          var meta = this.querySelector('[data-gtap-film-meta]');
          var title = this.querySelector('[data-gtap-film-title]');
          var link = this.querySelector('[data-gtap-film-link]');
          var img = stage.querySelector('img');
          var src = card.getAttribute('data-image');
          var srcset = card.getAttribute('data-srcset');

          if (img && src) {
            img.setAttribute('src', src);
            if (srcset) img.setAttribute('srcset', srcset);
            img.setAttribute('alt', card.getAttribute('data-title') || '');
          }
          if (meta) meta.textContent = card.getAttribute('data-meta') || '';
          if (title) title.textContent = card.getAttribute('data-title') || '';
          if (link) {
            var href = card.getAttribute('data-link');
            if (href) {
              link.setAttribute('href', href);
              link.hidden = false;
            } else {
              link.hidden = true;
            }
          }
          Array.prototype.forEach.call(this.querySelectorAll('[data-gtap-film]'), function (c) {
            c.setAttribute('aria-current', c === card ? 'true' : 'false');
          });
        }
      }
    );
  }

  /* ---------- theme editor plumbing ---------- */
  if (DESIGN && !window.__gtapHomeEditorBound) {
    window.__gtapHomeEditorBound = true;

    document.addEventListener('shopify:block:select', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var films = t.closest('gtap-films');
      if (films) {
        var card = t.matches('[data-gtap-film]') ? t : t.querySelector('[data-gtap-film]');
        if (card && films.select) films.select(card);
        return;
      }

      var explorer = t.closest('gtap-explorer');
      if (explorer) {
        var slide = t.matches('[data-gtap-cat-slide]') ? t : t.querySelector('[data-gtap-cat-slide]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
